import React from 'react';
import Badge from 'components/base/Badge';
import { useTranslation } from 'react-i18next';

interface SelectionCountBadgeProps {
  count: number;
}

const SelectionCountBadge: React.FC<SelectionCountBadgeProps> = ({ count }) => {
  const { t } = useTranslation();
  
  if (count === 0) return null;
  
  return (
    <Badge
      bg="warning"
      className="ms-2 fs--1"
      style={{ 
        verticalAlign: 'middle',
        minWidth: '1.5rem',
        height: '1.5rem',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        padding: '0 0.5rem'
      }}
      pill
    >
      {count}
    </Badge>
  );
};

export default SelectionCountBadge;
